import { cn } from "@/lib/utils";
import { Check } from "lucide-react";

const steps = [
  { id: 1, name: "Paziente", path: "/patients" },
  { id: 2, name: "Prestazioni", path: "/services" },
  { id: 3, name: "Acquisizione", path: "/devices" },
  { id: 4, name: "Risultati", path: "/results" },
  { id: 5, name: "Esporta", path: "/export" },
];

export const StepIndicator = ({ currentStep }) => {
  return (
    <nav className="py-4 px-4 md:px-6">
      <ol className="flex items-center justify-between md:justify-center md:gap-8">
        {steps.map((step, index) => {
          const isCompleted = step.id < currentStep;
          const isCurrent = step.id === currentStep;
          const isUpcoming = step.id > currentStep;

          return (
            <li key={step.id} className="flex items-center">
              <div className="flex flex-col items-center">
                {/* Step circle */}
                <div
                  className={cn(
                    "flex h-8 w-8 md:h-10 md:w-10 items-center justify-center rounded-full border-2 transition-all duration-300",
                    isCompleted && "border-primary bg-primary text-primary-foreground",
                    isCurrent && "border-primary bg-primary/10 text-primary shadow-glow",
                    isUpcoming && "border-muted bg-muted text-muted-foreground"
                  )}
                >
                  {isCompleted ? (
                    <Check className="h-4 w-4 md:h-5 md:w-5" />
                  ) : (
                    <span className="text-xs md:text-sm font-semibold">{step.id}</span>
                  )}
                </div>
                {/* Step name */}
                <span
                  className={cn(
                    "mt-1 text-[10px] md:text-xs font-medium transition-colors duration-300",
                    isCompleted && "text-primary",
                    isCurrent && "text-primary",
                    isUpcoming && "text-muted-foreground"
                  )}
                >
                  {step.name}
                </span>
              </div>
              {/* Connector line */}
              {index < steps.length - 1 && (
                <div
                  className={cn(
                    "hidden md:block h-0.5 w-12 lg:w-20 mx-2 transition-colors duration-300",
                    isCompleted ? "bg-primary" : "bg-muted"
                  )}
                />
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default StepIndicator;